export default __webpack_public_path__ + "static/media/right-arrow-next.60db0d08.svg";